/**
 * Буцаалтын төрөл, мөнгө буцаах хэлбэр — буцаалтын хуудас, захиалгын
 * модал, хуанли гурав ИЖИЛ нэрээр харуулна (2026-10-03).
 */

import type { RefundMethod, ReturnType } from '@boots/schema';
import { PAYMENT_LABEL } from './types';

export const RETURN_TYPE_LABEL: Record<ReturnType, string> = {
  REFUND: 'Бүтэн буцаалт',
  EXCHANGE: 'Солилцоо',
};

const REFUND_METHODS: readonly RefundMethod[] = ['CASH', 'CARD', 'QPAY', 'TRANSFER'];

export const REFUND_METHOD_OPTIONS = REFUND_METHODS.map((m) => ({ value: m, label: PAYMENT_LABEL[m] ?? m }));

/**
 * Анх яаж төлсөн тэрээр нь буцаах нь ердийн — картаар төлсөн бол карт руу.
 * Зээлийн апп, хувь зээл, холимог бол бэлэн (кассчин сольж болно).
 */
export function defaultRefundMethod(orderPayment: string | null | undefined): RefundMethod {
  return REFUND_METHODS.find((m) => m === orderPayment) ?? 'CASH';
}
